import React, { useContext, useEffect } from "react";
import { LanguageContext } from "../../context/LanguageContext";
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js';

// Import promo images
import img1 from "../../assets/banners/image001.jpg";
import img2 from "../../assets/banners/image002.jpg";
import img3 from "../../assets/banners/image003.jpg";
import img4 from "../../assets/banners/image004.jpg";
import img5 from "../../assets/banners/image005.jpg";
import img6 from "../../assets/banners/image006.jpg";
import img7 from "../../assets/banners/image007.jpg";
import img8 from "../../assets/banners/image008.jpg";


const HeroSection = () => {
  const { t } = useContext(LanguageContext);
  const promoImages = [img2, img5, img7, img6, img1, img3, img8, img4];

  useEffect(() => {
    const carouselEl = document.getElementById('promoCarousel');
    if (carouselEl) {
      new bootstrap.Carousel(carouselEl, {
        interval: 3000,
        ride: 'carousel',
        pause: false,
      });
    }
  }, []);
  return (
    <section className="w-100 bg-white p-0 m-0">
      <div className="">
        <div
          id="promoCarousel"
          className="carousel slide carousel-fade"
          data-bs-ride="carousel"
          data-bs-interval="3000"
        >
          <div className="carousel-inner">
            {promoImages.map((img, index) => (
              <div
                key={index}
                className={`carousel-item ${index === 0 ? "active" : ""}`}
              >
                <div className="w-100 text-center bg-white">
                  <img
                    src={img}
                    className="img-fluid rounded"
                    alt={`Promo ${index + 1}`}
                    loading="lazy"
                    decoding="async"
                    style={{
                      width: "100%",
                      height: "auto",
                      objectFit: "contain",
                      maxHeight: "280px",
                    }}
                  />
                </div>
              </div>
            ))}
          </div>
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#promoCarousel"
            data-bs-slide="prev"
          >
            <span className="carousel-control-prev-icon" aria-hidden="true" style={{ filter: "invert(1)" }}></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#promoCarousel"
            data-bs-slide="next"
          >
            <span className="carousel-control-next-icon" aria-hidden="true" style={{ filter: "invert(1)" }}></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>

      

      {/* ✅ Heading */}
      <div className="text-center mt-4 px-4">
        <h1 className="text-xl sm:text-2xl md:text-4xl font-bold text-gray-800">
          {t("title")}
        </h1>
      </div>
    </section>
  );
};

export default HeroSection;
